import { ProjectFeedResultAjax } from '@shared/datastore/project-feed';

declare module '../core/backend' {
  interface BackendAjaxFetchTypes {
    projectFeedFailingProjects: ProjectFeedResultAjax;
  }
}

export const projectFeedFailingProjectsBackend = {
  fetch: () => ({
    endpoint: `navigation/project-feed/pre-populated-xp-projectcontest.php`,
    isGaf: true,
    params: { type: 'p' },
  }),
};



// WEBPACK FOOTER //
// ./src/app/@shared/datastore/project-feed-failing-projects/project-feed-failing-projects.backend.ts